import React from 'react';
import config from 'config';
import { checkAdmin } from 'utils/permissions';

const Context = React.createContext();

// Key the axios client reads to scope a merchant to a single branch. Empty = all.
export const SELECTED_BRANCH_KEY = '__SELECTED_BRANCH__';

let user;
const tokenString = sessionStorage.getItem(config.TOKEN);
const userObj = JSON.parse(tokenString);
if (userObj) {
  const { token, ...rest } = userObj;
  user = rest;
} else {
  user = null;
}

const AuthProvider = (props) => {
  const [userDetails, setUserDetails] = React.useState(user);
  const [isAdmin, setIsAdmin] = React.useState(false);
  const [isMerchant, setIsMerchant] = React.useState(false);
  const [selectedBranchId, setSelectedBranchIdState] = React.useState(
    sessionStorage.getItem(SELECTED_BRANCH_KEY) || '',
  );

  React.useEffect(() => {
    setIsMerchant(userDetails?.role === 'merchant');
    setIsAdmin(userDetails?.role !== 'merchant' && checkAdmin(userDetails?.permissions));
  }, [userDetails]);

  // Persist the selection so the axios interceptor can append branch_id, and so
  // it survives a reload.
  const setSelectedBranchId = React.useCallback((id) => {
    if (id) sessionStorage.setItem(SELECTED_BRANCH_KEY, String(id));
    else sessionStorage.removeItem(SELECTED_BRANCH_KEY);
    setSelectedBranchIdState(id ? String(id) : '');
  }, []);

  const branches = userDetails?.branches || [];

  return (
    <Context.Provider
      value={{
        userDetails,
        setUserDetails,
        isAdmin,
        isMerchant,
        branches,
        selectedBranchId,
        setSelectedBranchId,
      }}
      {...props}
    />
  );
};

export function useAuth() {
  const context = React.useContext(Context);

  if (context === undefined) {
    throw new Error('useAuth must be used within a AuthProvider');
  }

  return context;
}

export default AuthProvider;
